'use strict';

import {attachSelect} from "../../components/form/select";
import attachColorPicker from "../../plugins/bootstrap/colorpicker";
import execute_on from "../../libs/execute-on";
import attachAdvancedSettings from "../../components/survey/attach-advanced-settings";
import {swalConfirmFire, swalWarningFire} from "../../plugins/sweet-alert/sweet-alert-default";

function generalScript() {
    const $unlimitedTargetCheckbox = $('#unlimited-target');
    let $scaleYesLabel = $('#scale_yes_label');
    let $scaleNoLabel = $('#scale_no_label');
    let $scaleHardToTellLabel = $('#scale_hard_to_tell_label');
    let $language = $('#language_id');
    let scaleLabels = $language.data('scale-labels');
    let $scale = $('#scale_id');

    function setSampleState() {
        const isUnlimitedTargetChecked = $unlimitedTargetCheckbox.prop('checked');
        $('#targetGeneral, #oversamplingGeneral').prop('readonly', isUnlimitedTargetChecked);
        $('.input-group-prepend, .input-group-append').children().prop('disabled', isUnlimitedTargetChecked);
    }

    // change states of target and oversampling after checkbox changes its state
    $unlimitedTargetCheckbox.change(function () {
        setSampleState();
    });
    // set states on page load
    setSampleState();

    $(document.getElementById('sample.is_enabled')).on('change', function () {
        $('.sample-enabled').toggleClass('hide', !$(this).is(':checked'));
    })

    $('#layout-restore-default').click(function () {
        const $target = $($(this).data('target'));
        $.get($(this).data('url'))
            .done(function (response) {
                const $html = $(response);
                attachSelect($html);
                attachColorPicker($html);
                $target.html($html);
                $('#colorpicker-background, #colorpicker-bar, #colorpicker-font, #colorpicker-buttons').trigger('change');
            });
    })

    function setScaleLabels() {
        if ($language.val()) {
            $scaleYesLabel.val(scaleLabels[$language.val()].yes);
            $scaleNoLabel.val(scaleLabels[$language.val()].no);
            $scaleHardToTellLabel.val(scaleLabels[$language.val()].hard_to_tell);
        }
    }

    const startLanguage = $language.val();
    $language.on('select2:select', function() {
        if (startLanguage === '') {
            setScaleLabels();

            return;
        }

        swalConfirmFire({
            title: 'Are you sure that you want to proceed?',
            text: 'You are trying to change the language of the survey you are currently working on. Remember, that if you have already modified some instructions in the survey, they are going to be reverted to default versions.',
            icon: 'question'
        })
            .then(result => {
                if (!result.isConfirmed) {
                    $language.val(startLanguage).trigger('change');

                    return;
                }

                setScaleLabels();
            });
    });

    $scale.on('change', function() {
        let specificSelector;
        switch ($(this).val()) {
            case $(this).data('3-point-scale'):
                specificSelector = '.point-3-scale-label';
                break;
            case $(this).data('2-point-scale'):
                specificSelector = '.point-2-scale-label';
                break;
        }
        $('.scale-label' + specificSelector).slideDown();
        $('.scale-label:not('+ specificSelector +')').slideUp();
    })

    attachAdvancedSettings();
}

execute_on('survey.general.edit', generalScript);
execute_on('survey.general.create', generalScript);
